import { parseISO, startOfDay, formatISO, isBefore } from 'date-fns';
/**
 * Converts an ISO date to local timezone, then resets the time to 0
 *
 * @param isoDate Date in ISO format
 * @returns Date in ISO format
 */
export const resetDay = (isoDate) => formatISO(startOfDay(parseISO(isoDate)));
export const isYesterdayOrOlder = (date) => isBefore(startOfDay(parseISO(date)), startOfDay(new Date()));
